import { render, staticRenderFns } from "./widget-modelView.vue?vue&type=template&id=597e405a&scoped=true"
import script from "./widget-modelView.vue?vue&type=script&lang=js"
export * from "./widget-modelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e405a",
  null
  
)

export default component.exports